import { FormattedMessage } from 'react-intl';
import { BackButton } from '../Login.styles';
import { Flex } from '@components';

import { PropsWithChildren } from 'react';

export interface MessageContainerProps extends PropsWithChildren {
  isMobile: boolean;
  onBackClick: () => void;
}

export const MessageContainer: React.FC<MessageContainerProps> = ({
  children,
  isMobile,
  onBackClick,
}) => {
  return (
    <Flex
      height='100vh'
      flexDirection='column'
      gap={19}
      sx={{
        maxWidth: isMobile ? '100%' : 750,
        width: '100%',
        flex: 1,
        alignItems: 'flex-start',
        alignSelf: 'center',
      }}
    >
      <BackButton
        variant='tertiary'
        color='primary'
        data-testid='login-qr-back-button'
        onClick={onBackClick}
        sx={{ mt: 10 }}
      >
        <FormattedMessage id='misc.back' />
      </BackButton>
      {children}
    </Flex>
  );
};
